/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */
export const yourCarFormInitialValues = {
  carReg: '',
  carMake: '',
  carModel: '',
  carYear: '',
  carFuelType: '',
  carEngineSize: '',
  carVersion: '',
  carPurchased: '',
  vehicleValue: '',
  carUsedForWork: '',
  drivingExpType: '',
  noClaimsBonus: '',
  isManualSearch: false,
  ncbCountry: ''
};

export const yourCarFormFieldsList = [
  'carReg',
  'carMake',
  'carModel',
  'carYear',
  'carFuelType',
  'carEngineSize',
  'carVersion',
  'carPurchased',
  'vehicleValue',
  'carUsedForWork',
  'drivingExpType',
  'noClaimsBonus',
  'isManualSearch'
];
